"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.overviewSteps = void 0;
exports.overviewSteps = {
    createAccount: {
        label: 'Create account',
        description: '',
        completed: true, // this is always true
    },
    signMNDA: {
        label: 'Review and sign MNDA',
        description: 'To protect your information we require all companies to review and sign a Mutual Non-Disclosure Agreement.',
        altDescription: 'Our team is preparing your MNDA form. Please check your email and sign the updated document to continue.',
        completed: false,
        actionText: `Let's go`,
        pillText: 'Pending',
        actionOnClick: 'signMNDA',
    },
    buildDataRoom: {
        label: 'Build your Data room',
        description: `We'll review your documents to evaluate your business' financial health. The more data you provide, the better results you will achieve on your underwriting.`,
        completed: false,
        actionText: `Let's go`,
        actionOnClick: 'signMNDA',
    },
};
//# sourceMappingURL=Overview.js.map